import { render, staticRenderFns } from "./QuestionControl.vue?vue&type=template&id=94e91dd0"
import script from "./QuestionControl.vue?vue&type=script&lang=ts"
export * from "./QuestionControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports